import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import homeFill from '@iconify/icons-eva/home-fill';
import personFill from '@iconify/icons-eva/person-fill';
import settings2Fill from '@iconify/icons-eva/settings-2-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// material
import { alpha } from '@mui/material/styles';
import {
  Button,
  Card,
  Stack,
  Box,
  Divider,
  MenuItem,
  Typography,
  Avatar,
  IconButton
} from '@mui/material';

// components
import { MHidden } from '../../components/@material-extend';
import MenuPopover from '../../components/MenuPopover';
//
import { useAuth } from '../../components/customContextProviders/AuthContext';
import { adminLogOut } from '../../network/User';
import { capitalizeFirstLetter, getAdminRoleFromHierarchy } from '../../utils/Utilities';
import { APP_CONSTANTS } from '../../URLConstants';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: homeFill,
    linkTo: '/'
  },
  {
    label: 'Profile',
    icon: personFill,
    linkTo: '/dashboard/userProfile'
  }
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const navigate = useNavigate();
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);

  //
  const { sessionUserData, accountDetails } = useAuth();
  const { logoutSession } = useAuth();
  const { userLoginOrg } = useAuth();
  let logoImage;

  if (userLoginOrg === APP_CONSTANTS?.BOM_CLIENT_IDENTIFIER) {
    logoImage = '/static/icons/bom-icon.png';
  } else if (userLoginOrg === APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER) {
    logoImage = '/static/icons/cbi_icon.png';
  } else if (userLoginOrg === APP_CONSTANTS?.IOB_CLIENT_IDENTIFIER) {
    logoImage = '/static/icons/iob_icon.png';
  } else if (userLoginOrg === APP_CONSTANTS?.UJN_CLIENT_IDENTIFIER) {
    logoImage = '/static/icons/ujn_icon.svg';
  } else if (userLoginOrg === APP_CONSTANTS?.KAGB_CLIENT_IDENTIFIER) {
    logoImage = '/static/icons/kagb_icon.png';
  } else if (userLoginOrg === APP_CONSTANTS?.NPST_CLIENT_IDENTIFIER) {
    logoImage = '/static/icons/npst_logo.jpg';
  } else {
    logoImage = process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ICON;
  }
  const handleOpen = (event) => {
    setOpen(true);
    anchorRef.current = event.currentTarget; // Ensure correct anchor reference
  };
  const handleClose = () => {
    setOpen(false);
  };

  const onLogout = () => {
    signout();
  };

  function signout() {
    adminLogOut()
      .then((_res) => {
        logoutSession();
      })
      .catch((_err) => {
        alert('Oops something went wrong, please try again !');
      });
  }
  const sessionUserPath = accountDetails?.path;

  return (
    <>
      <MHidden width="smUp">
        <Card sx={{ radius: '10px', minWidth: '50px', p: 0.5 }} onClick={handleOpen}>
          <IconButton
            ref={anchorRef}
            sx={{
              padding: 0,
              width: 44,
              height: 44,
              ...(open && {
                '&:before': {
                  zIndex: 1,
                  content: "''",
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  position: 'absolute',
                  bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
                }
              })
            }}
          >
            <Avatar alt="photoURL" />
          </IconButton>
        </Card>
      </MHidden>
      <MHidden width="smDown">
        <Card
          sx={{ radius: '10px', minWidth: { md: '220px', xs: '150px' }, p: 0.5 }}
          onClick={handleOpen}
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <IconButton
              ref={anchorRef}
              sx={{
                padding: 0,
                width: 44,
                height: 44,
                ...(open && {
                  '&:before': {
                    zIndex: 1,
                    content: "''",
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    position: 'absolute',
                    bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72)
                  }
                })
              }}
            >
              <Avatar alt={logoImage} />
            </IconButton>

            <Box>
              <Typography sx={{ lineHeight: '17px', fontWeight: 700, fontSize: '14px' }}>
                {sessionUserData?.user?.name}
              </Typography>
              <Typography sx={{ lineHeight: '15px', fontWeight: 400, fontSize: '12px' }}>
                {sessionUserData?.user?.role === APP_CONSTANTS?.USER_ROLE_ADMIN
                  ? getAdminRoleFromHierarchy(sessionUserPath)
                  : sessionUserData?.user?.role}
              </Typography>
            </Box>
          </Stack>
        </Card>
      </MHidden>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle1" noWrap>
            {sessionUserData?.user?.name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {sessionUserData?.user?.email}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Box
              component={Icon}
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button onClick={onLogout} fullWidth color="inherit" variant="outlined">
            Logout
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}
